import React from 'react'
import { SxProps } from '@mui/material'
import Button from 'components_new/atoms/Button'
import Icon, { IconName } from 'components_new/atoms/Icon'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'
import { useIsMobile } from 'utils/hooks'
import Grid from 'components_new/atoms/Grid'
import { useCustomer } from 'redux/hooks/Customer'
import Box from 'components_new/atoms/Box'

interface HomeQuickLinksProps {
  sx?: SxProps
}

const HomeQuickLinks = (props: HomeQuickLinksProps) => {
  const { sx } = props

  const { t } = useTranslation()
  const customer = useCustomer()
  const { isCompanyGroup } = useAccountSettings()
  const isMobile = useIsMobile()

  const GRID_SIZE = {
    xs: 12,
    sm: 6,
    md: 4
  }

  const items: {
    hidden?: boolean
    href: string
    search?: string
    iconName: IconName
    title: string
  }[] = [
    {
      hidden: !customer?.allow_access.allow_key_metrics || isCompanyGroup,
      href: '/key-metrics',
      iconName: 'KeyMetrics',
      title: t('key_metrics', 'key_metrics')
    },
    {
      hidden: !customer?.allow_access.allow_key_metrics || isCompanyGroup,
      href: '/tasks',
      iconName: 'Tasks',
      title: t('tasks', 'tasks')
    },
    {
      hidden: isCompanyGroup,
      href: '/groups',
      iconName: 'Groups',
      title: t('global', 'groups')
    },
    {
      href: '/resources',
      search: '?type=dashboard',
      iconName: 'Dashboards',
      title: t('global', 'dashboards')
    },
    {
      hidden: isMobile,
      href: '/templates',
      iconName: 'Templates',
      title: t('global', 'templates')
    },
    {
      hidden: isCompanyGroup,
      href: '/metrics',
      iconName: 'Metrics',
      title: t('metrics', 'metrics')
    }
  ]

  return (
    <Grid container={true} spacing={2} sx={sx}>
      {items.map((item) => {
        if (item.hidden) return null

        return (
          <Grid item={true} key={item.href} {...GRID_SIZE}>
            <Box
              sx={{
                bgcolor: 'background.default',
                borderRadius: 1,
                overflow: 'hidden'
              }}
            >
              <Button
                fullHeight={true}
                fullWidth={true}
                href={item.href}
                search={item.search}
                size="gigantic"
                startIcon={<Icon name={item.iconName} />}
                sx={{
                  borderRadius: 1,
                  height: 128
                }}
                variant="text"
              >
                {item.title}
              </Button>
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default HomeQuickLinks
